import { createFileRoute } from '@tanstack/react-router';
import { MembersPage } from '../components/pages/MembersPage/MembersPage';

export const Route = createFileRoute('/account/members')({
  component: MembersPage,
});
